import { IController, IScope } from "angular";
import {  } from "@idha/idha-types";
import * as Raven from 'raven-js'
import {Address,IAddressService  } from "../../services/addressService"
import { utilsModule } from "../../utils-module";

/**
 * @ngdoc component
 * @name app.component:postalCodeInput
 * @author William
 * @email william@idha.com.br
 * @description 
 * 
 * <b>IDHA TECNOLOGIA</b>
 * 
 * Nome do Componente: 'postalCodeInput'
 * 
 * Criação: 2019-1-2 19:18:06
 * 
 * Código do componente: CMP0013
 * 
 * Autor:  William 
 * 
 * Componente para informação de código postal.
 * Quando o país selecionado é o Brasil, o campo referencia o CEP, usa validação
 * de 8 dígitos numéricos e busca o endereço a partir do CEP
 * 
 * Especificação: <a>CMP0013 - Campo de informação de Código Postal (CEP/ZIP)</a>
 * @see http://wiki.idha.com.br/index.php/CMP0013_-_Campo_de_informa%C3%A7%C3%A3o_de_C%C3%B3digo_Postal_(CEP/ZIP)
 * 
 * @param {string} ngModel modelo a receber o CEP digitado
 * @param {boolean} ngRequired indica se o elemento será requerido ou não
 * @param {string} countryName nome do país ao qual pertence o CEP a ser informado
 * @param {Object} form referência para o formulário no qual o componente está contido, para validações
 * @param {boolean} showError Indica se os erros de validação devem ser exibidos
 * @param {string} class Classe css a ser aplicada sobre o componente
 * @param {string} stateSigle modelo a receber a sigla do estado ao realizar busca do codigo postal
 * @param {string} cityName modelo a receber o nome da cidade ao realizar busca do codigo postal
 * @param {string} district modelo a receber o nome do bairro ao realizar busca do codigo postal
 * @param {string} address modelo a receber o endereço ao realizar busca do codigo postal
 */
utilsModule.component('postalCodeInput', {
    template: require('./postal-code-input.component.html'),
    controller: ['addressService','LoadingBar','$timeout',postalCodeInputController],
    bindings: {
        ngModel: '=',
        ngRequired:'<?',
        countryName: '=' ,        
        form:'=',
        showError:'=',
        class:'@?',

        stateSigle:'=',
        cityName:'=',
        district:'=',
        address:'='
    }
})

/**
 * @interface
 * @ngdoc controller 
 * @name app.controller:IpostalCodeInputController 
 * @description
 * 
 * Interface do controlador do componente postalCodeInput
 */
export interface IpostalCodeInputController extends IController {
    /**
     * @ngdoc property
     * @name IpostalCodeInputController#ngModel
     * @propertyOf app.controller:IpostalCodeInputController
     * @description
     * 
     * Modelo a receber o CEP digitado
     */
    ngModel: string
    
    /**
     * @ngdoc property
     * @name IpostalCodeInputController#countryName
     * @propertyOf app.controller:IpostalCodeInputController
     * @description
     * 
     * nome do país ao qual pertence o CEP a ser informado
     */
    countryName: string
    
    /**
     * @ngdoc property
     * @name IpostalCodeInputController#form
     * @propertyOf app.controller:IpostalCodeInputController
     * @description
     * 
     * referência para o formulário no qual o componente está contido, para validações
     */
    form: any
    
    /**
     * @ngdoc property
     * @name IpostalCodeInputController#showError
     * @propertyOf app.controller:IpostalCodeInputController
     * @description
     * 
     * Indica se os erros de validação devem ser exibidos
     */
    showError: boolean
    
    /**
     * @ngdoc property
     * @name IpostalCodeInputController#class
     * @propertyOf app.controller:IpostalCodeInputController
     * @description
     * 
     * Classe css a ser aplicada sobre o componente
     */
    class: string
    
    /**
     * @ngdoc property
     * @name IpostalCodeInputController#ngRequired
     * @propertyOf app.controller:IpostalCodeInputController
     * @description
     * 
     * Indica se o elemento srá requerido ou não
     */
    ngRequired: boolean
  
    /**
     * @ngdoc property
     * @name IpostalCodeInputController#stateSigle
     * @propertyOf app.controller:IpostalCodeInputController
     * @description
     * 
     *  modelo a receber a sigla do estado ao realizar busca do codigo postal
     */
    stateSigle: string

    /**
     * @ngdoc property
     * @name IpostalCodeInputController#cityName
     * @propertyOf app.controller:IpostalCodeInputController
     * @description
     * 
     * modelo a receber o nome da cidade ao realizar busca do codigo postal
     */
    cityName: string

    /**
     * @ngdoc property
     * @name IpostalCodeInputController#district
     * @propertyOf app.controller:IpostalCodeInputController
     * @description
     * 
     * modelo a receber o nome do bairro ao realizar busca do codigo postal
     */
    district: string

    /**
     * @ngdoc property
     * @name IpostalCodeInputController#address
     * @propertyOf app.controller:IpostalCodeInputController
     * @description
     * 
     * modelo a receber o endereço ao realizar busca do codigo postal
     */
    address: string

    
   
    /**
     * @ngdoc method
     * @name IpostalCodeInputController#onChangeCEP
     * @methodOf app.controller:IpostalCodeInputController
     * @description
     * 
     * Evento a ser disparado ao sair do campo de CEP
     */
    onChangeCEP:() => Promise<void>

    /**
     * @ngdoc method
     * @name IpostalCodeInputController#$onInit
     * @methodOf app.controller:IpostalCodeInputController
     * @description
     * 
     * Inicialização do componente
     */
    $onInit:()=>void
}


/**
 * @name app.controller:postalCodeInputController 
 * @implements IpostalCodeInputController 
 * @description
 * 
 * Controlador do componente postalCodeInput
 */
function postalCodeInputController(addressService:IAddressService,LoadingBar,$timeout) {
    var ctrl: IpostalCodeInputController = this;

    ctrl.$onInit = function(){
        


        /*
        * @TODO: Trecho necessário devido a um bug no ng-required, no qual quando o mesmo é inicializado com FALSE,
        * o  mesmo é ignorado e a validação é feita, a menos que entre no campo, digite algo e depois apague.
        * Este trecho faz com que, nesses casos, a validação '''Required''' seja forçada para TRUE, indicando 
        * que o formulário é valido.
        * 
        * O timeout é utilizado sem parametro de tempo para garantir apenas que seja executado apos o ciclo de $digest,
        * onde os campos do formulario ja foram todos criados.    
        * 
        * Para este caso, o componente é recriado toda vez que o valor de countryname muda (devido ao ng-if),
        * portanto a verificação é feita sempre que esse campo mudar
        */
        initRequired();
        function initRequired(){            
            $timeout(()=>{
                if(ctrl.form && ctrl.form["inpZip"]){
                    if(!ctrl.ngRequired){
                        ctrl.form["inpZip"].$setValidity('required', true);
                    }
                }
            })
        }
    }

    ctrl.onChangeCEP = async function(){
        let cep: string = ctrl.ngModel;
        if (!cep || (cep == '')) {
            return;
        }

        LoadingBar.show();       
        try {
            let result:Address =  await addressService.findByZIP(cep);        
            ctrl.stateSigle    = result.state;
            ctrl.cityName      = result.city;
            ctrl.district      = result.district;
            ctrl.address       = result.address;
            await LoadingBar.hide();
        } catch (err) {
            console.error(err);
            await LoadingBar.hide();
            if (err.messageCode) {
                //dialogs.error($translate.instant(err.messageCode));
            } else {
                //dialogs.error($translate.instant('FAIL_ZIP_LOAD'));
            }
        }
    }
}